import DOMPurify from "dompurify";
import { marked } from "marked";

marked.setOptions({
  gfm: true,
  breaks: true,
  async: false,
});

const PURIFY_CONFIG = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: [
    "img",
    "svg",
    "math",
    "iframe",
    "object",
    "embed",
    "form",
    "input",
    "button",
    "textarea",
    "select",
    "option",
    "video",
    "audio",
    "source",
    "track",
    "canvas",
    "style",
  ],
  FORBID_ATTR: ["style", "srcset", "formaction"],
  ALLOW_DATA_ATTR: false,
  SANITIZE_DOM: true,
};

export function renderMarkdown(text: string): string {
  const raw = marked.parse(text, { async: false }) as string;
  return DOMPurify.sanitize(raw, PURIFY_CONFIG);
}

export function enhanceMarkdown(container: HTMLElement): void {
  container.querySelectorAll<HTMLAnchorElement>("a[href]").forEach((anchor) => {
    const href = anchor.getAttribute("href") ?? "";
    if (!/^(https?:|mailto:|#|\/)/i.test(href)) {
      anchor.removeAttribute("href");
      return;
    }
    anchor.setAttribute("rel", "noopener noreferrer");
    if (/^https?:/i.test(href)) {
      anchor.setAttribute("target", "_blank");
    }
  });

  container.querySelectorAll<HTMLPreElement>("pre").forEach((pre) => {
    if (pre.querySelector(".code-copy")) return;
    const code = pre.querySelector("code");
    if (!code) return;
    const button = document.createElement("button");
    button.type = "button";
    button.className = "code-copy";
    button.setAttribute("aria-label", "Copy code");
    button.textContent = "Copy";
    pre.appendChild(button);
  });
}
